import React from "react";
import { Loader } from "cxa-components";
import { withState } from "recompose";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const enhanceWithAgeRangeIndex = withState("ageRangeIndex", "setAgeRangeIndex", null);
const FaceAgeing = enhanceWithAgeRangeIndex(
  ({
    ageRangeList,
    healthyPhotosList,
    unhealthyPhotosList,
    faceAgingCompleted,
    agingPhotoSubmitted,
    ageRangeIndex,
    setAgeRangeIndex,
  }) => {
    if (!ageRangeList) {
      return <Loader />;
    }

    const currentAgeIndex = ageRangeIndex === null ? 0 : ageRangeIndex;

    const renderFaceAgeingSection = () => {
      if (!faceAgingCompleted && agingPhotoSubmitted) {
        return (
          <article className="card cxa-face-ageing">
            <Loader />
            <p>
              <FormattedMessage {...messages.faceAgingAppearDescription} />
            </p>
          </article>
        );
      }

      return (
        <article className="card cxa-face-ageing">
          <section>
            <figure>
              <img
                src={
                  healthyPhotosList[currentAgeIndex]
                    ? `${healthyPhotosList[currentAgeIndex]}`
                    : "/assets/images/wellness/view_aging_default.png"
                }
                alt="healthy"
              />
              <figcaption>
                <FormattedMessage {...messages.healthyLifestyleDescription} />
              </figcaption>
            </figure>
          </section>
          <section>
            <figure>
              <img
                src={
                  unhealthyPhotosList[currentAgeIndex]
                    ? `${unhealthyPhotosList[currentAgeIndex]}`
                    : "/assets/images/wellness/view_aging_default.png"
                }
                alt="unhealthy"
              />
              <figcaption>
                <FormattedMessage {...messages.currentLifestyleDescription} />
              </figcaption>
            </figure>
          </section>
          <section className="cxa-face-ageing__range">
            <p className="cxa-face-ageing__age">
              <strong>{ageRangeList[currentAgeIndex]}</strong>
            </p>
            <input
              type="range"
              onChange={e => setAgeRangeIndex(parseInt(e.target.value))}
              min="0"
              max={ageRangeList.length - 1}
              value={currentAgeIndex}
              step="1"
            />
            <p>
              <FormattedMessage {...messages.moveToChangeDescription} />
            </p>
          </section>
        </article>
      );
    };

    return renderFaceAgeingSection();
  }
);

export default FaceAgeing;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/faceAgeing.jsx